import React from 'react';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white p-4">
        <h1 className="text-xl font-bold">Gran Arquitectura</h1>
        <p className="text-white/80 text-sm">Portal de Contratistas</p>
      </div>
      <div className="p-4">
        <h2 className="text-lg font-bold">Bienvenido 👷</h2>
        <p className="text-gray-600">Módulo de contratistas en construcción</p>
      </div>
    </div>
  );
}

export default App;